import React from 'react';
import Disclaimer from 'components/common/general/Disclaimer';
import PopularPlansContent from 'components/popular-plans/PopularPlansContent';
import { createStyles } from '../../globalStyles';

const PopularPlansPage = (): JSX.Element => {
  const classes = createStyles();

  return (
    <div className={classes.widePageWrapper}>
      <PopularPlansContent />
      <Disclaimer />
    </div>
  );
};

export default PopularPlansPage;
